import React, { Component } from 'react';

import InputButton from '../../../../../components/ZUILib/InputButton';

import commonUtil from '../../../../../utils/commonUtil';

const channel = commonUtil.getChannel();

class BottomFormRegister extends Component {
  render() {
    const buttonAttrCancel = {
      onClickHandler: () => { this.props.redirectToPrevPage(); },
      value: 'Cancelar',
      style: (channel === 'wap') ? 'btnSecondaryAction size-Full' : 'btnSecondaryAction size-Large',
      cssStyle: { borderRadius: 4 },
    };

    const buttonAttrSave = {
      onClickHandler: this.props.validation,
      value: 'Guardar',
      style: (channel === 'wap') ? 'btnPrimary size-Full' : 'btnPrimary size-Large',
    };

    return (
      <React.Fragment>
        <div className={channel === 'wap' ? 'row form-legal-wrapper' : 'registerAddressFooterCreate'}>
          <div className={channel === 'wap' ? 'row legal legal-container' : ''} style={{textAlign:'end'}}>
            <div className="termsFooterFormRegister">
              <p>Al presionar &quot;Guardar&quot;, acepto los{' '}
                <a
                  href="https://assetspwa.liverpool.com.mx/ayuda/index.html#/sec/terminos-y-condiciones/proteccion-de-datos/aviso-clientes"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: 'var(--main-color-brand)', textDecoration: 'underline' }}
                >Términos y condiciones así, como las políticas de uso de datos.</a>
              </p>
            </div>
          </div>

          {channel === 'wap' ?
            <div className='buttonBlock-container'>
              <div style={{ display: 'flex', gap: 12}} className="buttonBlock">
                <InputButton buttonAttr={buttonAttrCancel}> Cancelar</InputButton>
                <InputButton buttonAttr={buttonAttrSave}> Guardar</InputButton>
              </div>
            </div>
            :
            <div style={{ display: 'flex', gap: 16 ,justifyContent:'end'}}>
              <InputButton buttonAttr={buttonAttrCancel}>Cancelar</InputButton>
              <InputButton buttonAttr={buttonAttrSave}>Guardar</InputButton>
            </div>
          }
        </div>
      </React.Fragment>
    );
  }
}

export default BottomFormRegister;
